export const state = () => {
  return {
    CLOUDINARY_NAME: process.env.CLOUDINARY_NAME,
    UPLOAD_PRESET: process.env.UPLOAD_PRESET,
  };
};
